<template>
  <div>
    <h4>Video</h4>

    <div class="row my-3">
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label for="vidname" class="col-sm-4 col-form-label"
              >Video Selector</label
            >

            <div class="col-sm-8">
              <select
                placeholder="Video Selector"
                id="vidname"
                class="custom-select"
                v-model="inputData.objectDbHash"
                @change="changeSelectedModel($event)"
              >
                <!-- <option disabled selected="true" value="undefined" >Character Selector</option> -->
                <option
                  v-for="(model, key) in getVideos"
                  :key="key"
                  :value="key"
                  >{{ model.name }}</option
                >
              </select>
            </div>
          </div>
          <!-- <div class="row form-group align-items-center">
            <label for="media_name" class="col-sm-4 col-form-label">
              Media Name
            </label>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="media_name"
                v-model="inputData.name" disabled
              />
            </div>
          </div> -->
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label"> Display Type </label>
            <div class="col-sm-8">
              <select
                placeholder="Select Media Type"
                class="custom-select"
                v-model="inputData.displayType"
              >
                <option value="Screen">Screen</option>
                <option value="Scene">Scene</option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="start_time" class="col-sm-4 col-form-label">
              Start Time
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="start_time"
                v-model="inputData.startTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="end_time" class="col-sm-4 col-form-label">
              End Time
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="end_time"
                v-model="inputData.endTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="video_duration_e" class="col-sm-4 col-form-label">
              Duration
            </label>
            <div class="col-sm-8">
              <input
                type="text"
                disabled
                v-model="inputData.presenceDuration"
                class="form-control"
                id="video_duration_e"
                :class="{'border-danger': (parseFloat(inputData.endTime) - parseFloat(inputData.startTime)).toFixed(2) <= 0}"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Volume
              </label>
              <div class="col-sm-8">
                <input type="range" min="0" max="1" step="0.1" v-model="inputData.videoSettings.volumeVideo">
                <span class="ml-2">{{ inputData.videoSettings.volumeVideo }}</span>
              </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Loop
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <div class="input-switch label-right p-0">
                  <input type="checkbox" v-model="inputData.videoSettings.videoLoop" id="loop">
                  <label for="loop" class="label-left">
                    <span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Scale
              </label>
              <div class="col-sm-8">
                <input type="range" min="0" max="1" step="0.1" v-model="inputData.scale">
                <span class="ml-2">{{ inputData.scale }}</span>
              </div>
          </div>
          <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Layer
              </label>
              <!-- <div class="col-sm-8">
                <input type="range" min="0" max="10" step="0.5" v-model="activeImage.layer" :readonly="activeImage.displayType == 'Scene'">
                <span class="ml-2">{{ activeImage.layer }}</span>
              </div> -->
              <div class="btn-group dropright col-sm-4">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Select an action
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" :class="inputData.layer >= layerStep ? 'disabled action-disabled' : ''" @click="bringToFront()">Bring to front</a>
                  <a class="dropdown-item" :class="inputData.layer >= layerStep ? 'disabled action-disabled' : ''" @click="changeLayer(1)">Bring forward</a>
                  <a class="dropdown-item" :class="inputData.layer <= -layerStep ? 'disabled action-disabled' : ''" @click="changeLayer(-1)">Send backward</a>
                  <a class="dropdown-item" :class="inputData.layer <= -layerStep ? 'disabled action-disabled' : ''" @click="sendToBack()">Send to back</a>
                </div>
              </div>
            </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Scene'">
            <label for="minimum_distance" class="col-sm-4 col-form-label">
              Minimum Distance
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="minimum_distance"
                v-model="inputData.minimumDistance"
              />
            </div>
          </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Scene'">
            <label for="maximum_distance" class="col-sm-4 col-form-label">
              Maximum Distance
            </label>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="maximum_distance"
                v-model="inputData.maximumDistance"
              />
            </div>
          </div>
          <div class="row form-group align-items-center py-3" v-if="inputData.displayType === 'Screen'">
            <label class="col-sm-4 col-form-label">
              Alignment
            </label>

            <div class="col-sm-8 align-items-center">
              <Icon icon="align_left" :color="inputData.objectTransformSimple.horizontal == 'left' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="horizontalAlignment('left')"/>
              <Icon icon="align_center" :color="inputData.objectTransformSimple.horizontal == 'center' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="horizontalAlignment('center')"/>
              <Icon icon="align_right" :color="inputData.objectTransformSimple.horizontal == 'right' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-4" @click="horizontalAlignment('right')"/>
              <Icon icon="align_bottom" :color="inputData.objectTransformSimple.vertical == 'bottom' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('bottom')"/>
              <Icon icon="align_middle" :color="inputData.objectTransformSimple.vertical == 'center' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('center')"/>
              <Icon icon="align_top" :color="inputData.objectTransformSimple.vertical == 'top' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('top')"/>

            </div>
          </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Screen'">
            <label for="offset_horizontal" class="col-sm-4 col-form-label">
              Offset Horizontal
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="offset_horizontal"
                v-model="inputData.objectTransformSimple.offsetHorizontal"
              />
            </div>
          </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Screen'">
            <label for="offset_vertical" class="col-sm-4 col-form-label">
              Offset Vertical
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="offset_vertical"
                v-model="inputData.objectTransformSimple.offsetVertical"
              />
            </div>
          </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Scene'">
            <label class="col-sm-4 col-form-label">
              Position of the Origin
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_x"
                  v-model="inputData.positionOfOrigin[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_y"
                  v-model="inputData.positionOfOrigin[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_z"
                  v-model="inputData.positionOfOrigin[2]"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center" v-if="inputData.displayType == 'Scene'">
            <label class="col-sm-4 col-form-label">
              Rotation of the Origin
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_x"
                  v-model="inputData.rotationOfOrigin[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_y"
                  v-model="inputData.rotationOfOrigin[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_z"
                  v-model="inputData.rotationOfOrigin[2]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from '../../../../../firebaseDB'
import { mapActions, mapGetters, mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import $ from 'jquery'
import Icon from '../../../../global/Icon.vue'

export default {
  components: {Icon},
  props: ['selectedCharecter', 'charData', 'currentIndex'],
  data () {
    return {
      layerStep: 10000,
      mainCharacterIndex: 0,
      // errorPresenceDuration: false,
      releaseLock: true,
      isLoaded: false,
      activeCharacter: {},
      inputData: {
        elementType: 'Video',
        mediaUrl: '',
        name: '',
        mediaType: '',
        layer: 1,
        selectedModel: null,
        maximumDistance: 0,
        minimumDistance: 0,
        startTime: 0,
        endTime: 0,
        typeOfDisplay: '',
        presenceDuration: 0,
        mediaHeight: 0,
        mediaWidth: 0,
        alignmentType: '',
        offsetHorizontal: 0,
        offsetVertical: 0,
        origin: {
          position: [0.0, 0.0, 0.0],
          rotation: [0, 0, 0],
          scale: [0, 0, 0]
        }
      },
      // objectId: Math.floor(Date.now() / 1000),
      saveData: {
        video: {
          mediaUrl: '',
          name: '',
          mediaType: '',
          layer: 1,
          maximumDistance: 0,
          minimumDistance: 0,
          startTime: 0,
          endTime: 0,
          typeOfDisplay: '',
          duration: 0,
          mediaHeight: 0,
          mediaWidth: 0,
          alignmentType: '',
          offsetHorizontal: 0,
          offsetVertical: 0,
          origin: {
            position: [0.0, 0.0, 0.0],
            rotation: [0, 0, 0],
            scale: [0, 0, 0]
          }
        }
      }
    }
  },
  created () {
    this.listVideos()
  },
  methods: {
    saveToDB () {
      this.saveData.video.mediaUrl = this.inputData.mediaUrl
      this.saveData.video.name = this.inputData.name
      this.saveData.video.mediaType = this.inputData.mediaType
      this.saveData.video.layer = this.inputData.layer
      this.saveData.video.maximumDistance = this.inputData.maximumDistance
      this.saveData.video.minimumDistance = this.inputData.minimumDistance
      this.saveData.video.startTime = this.inputData.startTime
      this.saveData.video.endTime = this.inputData.endTime
      this.saveData.video.duration = this.inputData.presenceDuration
      this.saveData.video.mediaHeight = this.inputData.mediaHeight
      this.saveData.video.mediaWidth = this.inputData.mediaWidth
      this.saveData.video.alignmentType = this.inputData.alignmentType
      this.saveData.video.offsetHorizontal = this.inputData.offsetHorizontal
      this.saveData.video.offsetVertical = this.inputData.offsetVertical
      this.saveData.video.origin = this.inputData.origin
      this.saveData.video.objectId = this.inputData.objectId
      this.saveData.video.type = 'Video'
      this.saveData.successCallback = this.showSuccessToast
      this.saveData.errorCallback = this.showErrorToast
      for (const [key, value] of Object.entries(this.fbxModels)) {
        if (value.name === this.inputData.name) {
          this.saveData.video.objectDbHash = key
          break
        }
      }
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      tRef.once('value').then(snapshot => {
        let json = snapshot.val().json
        let selectedNodePosition = this.selectedLogic.nodePosition
        for (const snapshotkey in json.mediaList.nodes[selectedNodePosition]
          .nodeElements) {
          if (
            json.mediaList.nodes[selectedNodePosition].nodeElements[
              snapshotkey
            ].hasOwnProperty('video') &&
            json.mediaList.nodes[selectedNodePosition].nodeElements[snapshotkey]
              .video.objectId == this.inputData.objectId
          ) {
            // if (
            //   json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
            //     .characterElements
            // ) {
            //   _this.saveData.character.characterElements = []
            //   for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[
            //     snapshotkey
            //   ].character.characterElements) {
            //     _this.saveData.character.characterElements.push(
            //       json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
            //         .characterElements[innerKey]
            //     )
            //   }
            // }
          }
        }
        _this.$store.dispatch('saveInspector', this.saveData)
        _this.releaseLock = true
      })
    },
    showSuccessToast () {
      this.$toast('Main inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Main inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    ...mapActions(['listVideos']),
    changeSelectedModel (event = null) {
      if (this.getVideos) {
        if (event) {
          let newCharacters = this.characters
          newCharacters = this.characters.map(char =>
            char.objectId === this.activeCharacter.objectId
              ? {
                ...char,
                objectDbHash: event.target.value,
                objectName: this.getVideos[event.target.value].name,
                objectUrl: this.getVideos[event.target.value]['video']
                    .videoURL,
                mediaType: this.getVideos[event.target.value].soundType,
                endTime:
                    parseInt(this.inputData.startTime) +
                    this.getVideos[event.target.value].duration,
                presenceDuration: this.getVideos[event.target.value].duration,
                duration: this.getVideos[event.target.value].duration
              }
              : { ...char }
          )
          document.getElementById('selectedVideoNode') &&
            (document.getElementById('selectedVideoNode').src = this.getVideos[
              event.target.value
            ]['video'].videoURL)
          this.$store.dispatch('updateCharacters', [])
          console.log(newCharacters)
          this.$store.dispatch('updateCharacters', newCharacters)
        }
      }
    },
    changeLayer(value) {
      this.inputData.layer  += value;
    },
    bringToFront() {
      this.inputData.layer = this.layerStep
    },
    sendToBack() {
      this.inputData.layer = - this.layerStep
    },
    getActiveChar () {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeCharacter = char
          found = true
        }
      }
      if (!found) {
        this.activeCharacter = this.characters[0]
      }
      // Checking if the field is diffent of the one in the activeCharacter
      // then affecting to it, otherwise there will be an infinite loop because of the inputData watcher
      if (this.activeCharacter) {
        this.inputData = this.activeCharacter;
        console.log(this.inputData.objectDbHash)
        this.inputData.presenceDuration =
          parseInt(this.inputData.startTime) + parseInt(this.inputData.endTime)
        this.inputData.duration = 
          parseInt(this.inputData.startTime) + parseInt(this.inputData.endTime)
        this.isLoaded = true
      }
    },
    horizontalAlignment(value) {
      this.inputData.objectTransformSimple.horizontal = value;
    },
    verticalAlignment(value) {
      this.inputData.objectTransformSimple.vertical = value;
    },
    dispatchActiveChar (data) {
      console.log(data)
      if (data) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === data.objectId
            ? {
              ...char,
              startTime: data.startTime,
              endTime: data.endTime,
              // presenceDuration: data.presenceDuration,
              mediaUrl: data.mediaUrl,
              name: data.name,
              mediaType: data.mediaType,
              typeOfDisplay: data.typeOfDisplay,
              maximumDistance: data.maximumDistance,
              minimumDistance: data.minimumDistance,
              mediaHeight: data.mediaHeight,
              mediaWidth: data.mediaWidth,
              layer: data.layer,
              alignmentType: data.alignmentType,
              offsetHorizontal: data.offsetHorizontal,
              offsetVertical: data.offsetVertical,
              origin: data.origin,
            }
            : char 
        )
        // document.getElementById('selectedVideoNode') &&
        //   (document.getElementById('selectedVideoNode').src =
        //     data.mediaUrl || '')
        if (JSON.stringify(this.characters) != JSON.stringify(newCharacters)) {
          console.log('dispatch')
          // this.$store.dispatch('updateCharacters', [])
          this.$store.dispatch('updateCharacters', newCharacters)
        }
      }
    }
  },
  mounted () {
    this.selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'))
    var newChars = []
    var val = this.characters
    for (let i = 0; i < val.length; i++) {
      const char = val[i]
      if (char.active) {
        this.activeCharacter = char
      }
    }

    this.getActiveChar()
  },
  watch: {
    characters (val) {
      this.isLoaded = false
      this.getActiveChar()
    },

    inputData: {
      handler: function (val, oldVal) {
        val.presenceDuration =
          parseInt(val.endTime) - parseInt(val.startTime)
        this.dispatchActiveChar(val)
        if (this.releaseLock && this.isLoaded) {
          this.releaseLock = false
          setTimeout(() => {
          }, 3000)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['characters', 'fbxModels', 'inspector']),
    ...mapGetters(['getStartTime', 'getEndTime', 'getCharacters', 'getVideos']),
  }
}
</script>
<style lang="scss" scoped>
.border-2 {
  border-width: 2px !important;
}
.action-disabled {
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/media-videos/maininspector.vue